import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const ADHDEvaluationsPage = lazy(() => import("../pages/adhd-evaluations/page"));
const MembershipPage = lazy(() => import("../pages/membership/page"));
const MeetLaurenPage = lazy(() => import("../pages/meet-lauren/page"));
const CoachingPage = lazy(() => import("../pages/coaching/page"));
const BookAppointmentPage = lazy(() => import("../pages/book-appointment/page"));
const ContactPage = lazy(() => import("../pages/contact/page"));
const NotFoundPage = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/adhd-evaluations",
    element: <ADHDEvaluationsPage />,
  },
  {
    path: "/membership",
    element: <MembershipPage />,
  },
  {
    path: "/meet-lauren",
    element: <MeetLaurenPage />,
  },
  {
    path: "/coaching",
    element: <CoachingPage />,
  },
  {
    path: "/book-appointment",
    element: <BookAppointmentPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;